import { createSlice } from '@reduxjs/toolkit';
import { TableData } from '@uikit/Tables/types';
import { auditLogsApi } from '@store/rtk/auditLogs';
import { formatFieldTitle } from '@utils/inputTitles';
import { formatUTCToLocal } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type PayorsAuditSliceType = {
  modificationHistoryData: TableData;
};

const initialState: PayorsAuditSliceType = {
  modificationHistoryData: {
    columns: [],
    rows: [],
    size: 5,
  },
};

export const payorsAuditSlice = createSlice({
  name: 'payorsAudit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      auditLogsApi.endpoints.getModificationHistory.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          const {
            rideOrStandingOrderModificationHistoryColumns,
            modificationHistoryColumns,
          } = TABLE_COLUMNS;
          state.modificationHistoryData = {
            ...state.modificationHistoryData,
            columns:
              payload.table === 'rideModification' ||
              payload.table === 'standingOrderModification'
                ? rideOrStandingOrderModificationHistoryColumns
                : modificationHistoryColumns,
            rows: [
              ...payload.content.map((el) => {
                const cleaned = Object.fromEntries(
                  Object.entries(el).filter(([_, value]) => value !== 'null')
                );
                return {
                  ...cleaned,
                  field: formatFieldTitle(el.field ? el.field : ''),
                  actionTime: formatUTCToLocal(el.actionTime),
                };
              }),
            ],
            ...payload,
            requestTablePageChange:
              auditLogsApi.endpoints.getModificationHistory,
          };
        }
      }
    );
  },
});
export const selectPayorsAudit = (state: {
  payorsAudit: PayorsAuditSliceType;
}) => state.payorsAudit;
export const payorsAuditReducer = payorsAuditSlice.reducer;
